import axiosInstance from ".";

export const registerUser = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/users/register", payload);
    return response.data;
  } catch (error) {
    console.error("Registration error:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });

    // Network or timeout error
    if (error.code === "ECONNABORTED" || error.code === "ERR_NETWORK") {
      return {
        success: false,
        message: `Network Error: Cannot connect to server. Please check your connection.`,
      };
    }

    return (
      error.response?.data || {
        success: false,
        message: error.message || "Registration failed",
      }
    );
  }
};

export const loginUser = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/users/login", payload);
    return response.data;
  } catch (error) {
    console.error("Login error details:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      config: error.config?.url,
    });

    // Network or timeout error
    if (error.code === "ECONNABORTED" || error.code === "ERR_NETWORK") {
      return {
        success: false,
        message: `Network Error: Cannot connect to server at ${error.config?.baseURL}. Please check if the backend server is running.`,
      };
    }

    // Server returned an error response
    if (error.response) {
      return error.response.data;
    }

    // Request was made but no response received
    return {
      success: false,
      message: `Connection failed: ${error.message}. Backend server may be down or unreachable.`,
    };
  }
};

export const getUserInfo = async () => {
  try {
    const response = await axiosInstance.post("/api/users/get-user-info");
    return response.data;
  } catch (error) {
    console.error("Get user info error:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });

    // Token expired or invalid - will be handled by interceptor
    if (error.response?.status === 401) {
      return {
        success: false,
        message:
          error.response.data?.message ||
          "Session expired. Please login again.",
      };
    }

    return (
      error.response?.data || {
        success: false,
        message: error.message || "Connection failed",
      }
    );
  }
};
